import React from 'react'
import cx from 'classnames'

import ELocale from '../../../../types/locales'
import { TItem } from '../../types'

const ServicesAreaItem: React.FC<{
  item: TItem
  locale: ELocale
  type: 'main' | 'meta'
  index: number
}> = (props) => {
  let content: string | React.ReactNode = props.item.label
  if (props.item.image) {
    content = (
      <img
        src={props.item.image}
        className={cx('block', {
          'h-16': props.type === 'main',
          'h-32': props.type === 'meta',
        })}
        alt={props.item.label}
      />
    )
  }
  if (props.item.icon) {
    content = props.item.icon
  }
  const href = typeof props.item.url === 'string' ? props.item.url : props.item.url[props.locale]
  return (
    <li
      className={cx('hyphens-auto', {
        block: props.type === 'main',
        'inline-block': props.type === 'meta',
        'ml-16': props.type == 'meta' && !props.item.icon && props.index > 0,
        'ml-8 md:ml-16': props.type === 'meta' && props.item.icon && props.index > 0,
      })}
    >
      <a
        href={href}
        className={cx('block', {
          'py-12': props.type === 'main',
          'py-0': props.type === 'meta',
        })}
      >
        {content}
      </a>
    </li>
  )
}

export { ServicesAreaItem as default }
